<template src="./Years.html"></template>

<script>

export default {
  name: 'years',
  props: ['years','period'],
  methods: {
    setYear: function(year) {
      this.$parent.year = year
      this.$parent.dateRedirect()
    }
  }
}

</script>


// WEBPACK FOOTER //
// Years.vue?0299e900